import { Navigate, Outlet, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader.tsx';
import { IS_AUTHENTICATED_KEY } from '~/modules/auth/constants.ts';
import type { RootState } from '~/store/store.ts';

const ProtectedTasksRoute = () => {
  const { pathname, search } = useLocation();
  const { token, loading, isInitialized, isManagerLogin } = useSelector(
    (state: RootState) => state.users
  );
  const isAuthorized = localStorage.getItem(IS_AUTHENTICATED_KEY);

  if ((!isInitialized || (loading && !token)) && isAuthorized) return <FullPageLoader />;
  if (!token || !isManagerLogin) {
    return <Navigate to="/manager/sign-in" state={{ from: `${pathname}${search}` }} replace />;
  }

  return <Outlet />;
};

export default ProtectedTasksRoute;
